<template>
    <main class="news-v2" role="main">
        <portal to="ariane">
            <div class="tbv2-page-title">
                <router-link to="/admin/news" class="tbv2-crumb">{{ $t('sensibilisation.page.title') }}</router-link>
                <span class="tbv2-sep">/</span>
                <span class="tbv2-current">{{ $t('sensibilisation.page.new') }}</span>
            </div>
        </portal>

        <header class="news-hero">
            <router-link to="/admin/news" class="news-back">
                <i class="fal fa-arrow-left"></i>
                <span>{{ $t('common.back') }}</span>
            </router-link>
            <h1 class="news-hero-title">{{ $t('sensibilisation.page.new') }}</h1>
        </header>

        <NewsForm
            mode="create"
            :categories="[]"
            :busy-action="busyAction"
            :title-placeholder="$t('sensibilisation.form.placeholder_title')"
            @submit="onSubmit"
            @cancel="goBack"
        />
    </main>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { mapActions } from 'vuex'
import NewsForm from '@/components/News/NewsForm.vue'

export default {
    name: 'GlobalNewsCreate',
    components: { NewsForm },
    data() {
        return {
            busyAction: null
        }
    },
    methods: {
        ...mapActions('globalNews', ['createArticle', 'publishArticle']),
        goBack() {
            this.$router.push({ name: 'AdminNews' })
        },
        async onSubmit({ action, payload }) {
            if (this.busyAction) return
            this.busyAction = action
            try {
                const response = await this.createArticle(payload)
                const created = (response && response.data && response.data.article) || null
                if (action === 'publish' && created && created.id) {
                    await this.publishArticle(created.id)
                }
                this.$store.dispatch('toast', {
                    type: 'success',
                    title: this.$t(action === 'publish' ? 'sensibilisation.actions.publish' : 'sensibilisation.actions.save_draft')
                })
                if (created && created.id) {
                    this.$router.push({ name: 'AdminNewsEdit', params: { id: created.id } })
                } else {
                    this.$router.push({ name: 'AdminNews' })
                }
            } catch (err) {
                this.$store.dispatch('dispatchError', err)
            } finally {
                this.busyAction = null
            }
        }
    }
}
</script>

<style scoped>
.news-v2 {
    width: 100%;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.news-hero {
    margin-bottom: var(--v2-space-6);
}

.news-back {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: var(--v2-text-xs-size);
    color: var(--v2-text-3);
    text-decoration: none !important;
    margin-bottom: 10px;
    transition: color var(--v2-transition-fast);
}

.news-back:hover {
    color: var(--v2-primary);
}

.news-hero-title {
    margin: 0;
    font-size: 1.75rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.15;
}

@media (max-width: 900px) {
    .news-v2 {
        padding: 16px 18px 32px;
    }
}
</style>
